import type { FeatureTabsContent } from '@/core/types';

import { FeatureTabsV1 } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: FeatureTabsContent;
  className?: string;
}) {
  return <FeatureTabsV1 items={content.items} className={className} />;
}
